import { render, staticRenderFns } from "./BaykedOrdersFeedback.vue?vue&type=template&id=e55e2dd6&scoped=true&"
import script from "./BaykedOrdersFeedback.vue?vue&type=script&lang=js&"
export * from "./BaykedOrdersFeedback.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55e2dd6",
  null
  
)

export default component.exports